import React from 'react'
import RecentServices from './RecentServices';

const Craftsman = [
    { imagesUrl: "Mask group (1)", name: "Alex" },
    { imagesUrl: "Mask group (2)", name: "Alex" },
    { imagesUrl: "Mask group (3)", name: "Alex" },
    { imagesUrl: "Mask group (4)", name: "Alex" },
    { imagesUrl: "Mask group (5)", name: "Alex" },
    { imagesUrl: "Mask group (6)", name: "Alex" },
]

 const VerfiedCraftsman = () =>{
    return (
        <>
          <div className='maincontainer'>
          <h2>Verfied Craftsman</h2>
            <div className='row'>
                {
                    Craftsman.map((craft, index) => {
                        return (
                            <div className="col-lg-2 col-md-4 col-sm-6">
                                <div className="verfied-crafts-imagebox" key={index}>
                                    <div className="verfied-crafts-thumbnail">
                                        <img src={`assets/images/${craft.imagesUrl}.png`} alt="" />
                                    </div>
                                    <div className="verfied-crafts-content">
                                        <div className="verfied-crafts-content-box-inner">
                                            <p>{craft.name}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
            <RecentServices />
            </div>
        </>
    )
}

export default VerfiedCraftsman;